import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface LogoProps {
  variant?: 'colored' | 'white';
  height?: number;
}

const LogoContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  transition: 'transform 0.3s ease',
  '&:hover': {
    transform: 'scale(1.05)',
  },
});

export default function Logo({ variant = 'colored', height = 50 }: LogoProps) {
  if (variant === 'white') {
    return (
      <LogoContainer>
        <svg
          id="katman_1"
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          viewBox="0 0 283 70"
          height={height}
          style={{ width: 'auto' }}
        >
          <defs>
            <style>
              {`
                .st-white {
                  fill: #FFFFFF;
                }
              `}
            </style>
          </defs>
          <g>
            <g>
              <polygon className="st-white" points="25.5 69.8 44.2 44.5 40.6 32.4 35.1 30.6 25.1 37.8 25.5 69.8"/>
              <path className="st-white" d="M45.4,25.8c-.9,2.9-4.1,4.5-7,3.6-2.9-.9-4.5-4.1-3.6-7,.9-2.9,4.1-4.5,7-3.6,2.9.9,4.5,4.1,3.6,7Z"/>
            </g>
            <g>
              <polygon className="st-white" points=".5 24.5 21.4 13.8 31.8 20.9 31.9 26.7 22 34.1 .5 24.5"/>
              <polygon className="st-white" points="72.1 47.5 61.3 26.6 48.7 26.4 45.3 31 49 42.8 72.1 47.5"/>
            </g>
            <polygon className="st-white" points=".8 23.5 21.7 12.9 32.1 20 32.2 25.7 22.3 33.2 .8 23.5"/>
            <polygon className="st-white" points="72.4 46.5 61.6 25.7 49 25.4 45.6 30 49.3 41.9 72.4 46.5"/>
            <polygon className="st-white" points="25.7 69.1 44.5 43.8 40.8 31.7 35.4 29.9 25.3 37.1 25.7 69.1"/>
            <path className="st-white" d="M45.6,25.1c-.9,2.9-4.1,4.5-7,3.6-2.9-.9-4.5-4.1-3.6-7,.9-2.9,4.1-4.5,7-3.6,2.9.9,4.5,4.1,3.6,7Z"/>
            <polygon className="st-white" points="24.4 11.4 47.5 1.1 60.4 23 51.4 22.4 45.3 8 31.9 16.2 24.4 11.4"/>
          </g>
          <g>
            <path className="st-white" d="M93.7,55c-1.2.7-3.1,1-5.6,1-6,0-8.9-3.1-8.9-9.3v-12.6h-4.4v-6.2h4.4v-5.9l8.4-2.4v8.3h6.2v6.2h-6.2v11.1c0,2.9,1.1,4.3,3.4,4.3s1.8-.3,2.8-.8v6.3Z"/>
            <path className="st-white" d="M118.4,44.1h-17.9c.3,4,2.8,6,7.5,6s5.7-.7,7.9-2.1v6.1c-2.5,1.4-5.8,2-9.9,2s-7.9-1.2-10.3-3.7-3.7-5.9-3.7-10.3,1.3-8.2,4-10.8c2.6-2.7,5.9-4,9.7-4s7.1,1.2,9.3,3.6c2.2,2.4,3.3,5.6,3.3,9.7v3.6ZM110.6,38.9c0-3.9-1.6-5.9-4.8-5.9s-2.5.6-3.5,1.7c-1,1.1-1.6,2.5-1.8,4.2h10.1Z"/>
            <path className="st-white" d="M146.6,55.4h-10.1l-8.8-13.6h-.1v13.6h-8.5V14.8h8.5v25.8h.1l8.2-12.7h10l-9.8,12.9,10.5,14.5Z"/>
            <path className="st-white" d="M171.8,55.4h-8.4v-15.2c0-4.2-1.5-6.4-4.6-6.4s-2.7.6-3.6,1.7c-.9,1.1-1.4,2.6-1.4,4.3v15.6h-8.5v-27.4h8.5v4.3h.1c2-3.3,5-5,8.8-5,6.1,0,9.1,3.8,9.1,11.3v16.8Z"/>
            <path className="st-white" d="M187.2,56c-4.6,0-8.2-1.3-10.8-3.8-2.6-2.6-3.9-6-3.9-10.4s1.4-8.1,4.1-10.6c2.7-2.6,6.4-3.8,11-3.8s8.1,1.3,10.7,3.8c2.6,2.6,3.9,5.9,3.9,10.2s-1.3,8.1-4,10.8c-2.7,2.6-6.3,4-11,4ZM187.4,33.8c-2,0-3.6.7-4.7,2.1-1.1,1.4-1.7,3.3-1.7,5.8,0,5.3,2.1,7.9,6.4,7.9s6.1-2.7,6.1-8.1-2-7.7-6.1-7.7Z"/>
            <path className="st-white" d="M211.7,55.4h-8.5V14.8h8.5v40.6Z"/>
            <path className="st-white" d="M227.5,56c-4.6,0-8.2-1.3-10.8-3.8-2.6-2.6-3.9-6-3.9-10.4s1.4-8.1,4.1-10.6c2.7-2.6,6.4-3.8,11-3.8s8.1,1.3,10.7,3.8c2.6,2.6,3.9,5.9,3.9,10.2s-1.3,8.1-4,10.8c-2.7,2.6-6.3,4-11,4ZM227.7,33.8c-2,0-3.6.7-4.7,2.1-1.1,1.4-1.7,3.3-1.7,5.8,0,5.3,2.1,7.9,6.4,7.9s6.1-2.7,6.1-8.1-2-7.7-6.1-7.7Z"/>
            <path className="st-white" d="M252.1,52.2h-.1v3.2h-8.5V14.8h8.5v17.3h.1c2.1-3.2,5.1-4.8,8.9-4.8s6.3,1.2,8.2,3.6c1.9,2.4,2.9,5.7,2.9,10s-1.1,8.2-3.3,11c-2.2,2.8-5.2,4.1-8.9,4.1s-5.9-1.3-7.7-3.9ZM251.9,40.6v2.8c0,1.8.5,3.2,1.5,4.4,1,1.2,2.3,1.7,3.9,1.7s3.4-.7,4.5-2.2c1.1-1.5,1.6-3.6,1.6-6.3s-.5-4-1.5-5.3c-1-1.3-2.4-1.9-4.2-1.9s-3.1.6-4.2,1.9-1.7,2.9-1.7,5Z"/>
            <path className="st-white" d="M277.5,23.6c-1.4,0-2.6-.4-3.5-1.3-.9-.8-1.4-1.9-1.4-3.1s.5-2.3,1.4-3.1c.9-.8,2.1-1.2,3.5-1.2s2.6.4,3.5,1.2c.9.8,1.4,1.8,1.4,3.1s-.5,2.3-1.4,3.2-2.1,1.2-3.5,1.2ZM281.7,55.4h-8.5v-27.4h8.5v27.4Z"/>
          </g>
        </svg>
      </LogoContainer>
    );
  }

  return (
    <LogoContainer>
      <svg
        id="katman_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        version="1.1"
        viewBox="0 0 283 70"
        height={height}
        style={{ width: 'auto' }}
      >
        <defs>
          <style>
            {`
              .st0 {
                fill: #0090d7;
              }
              .st1 {
                fill: url(#linear-gradient2);
              }
              .st2 {
                fill: url(#linear-gradient1);
              }
              .st3 {
                fill: url(#radial-gradient);
              }
              .st4 {
                fill: url(#linear-gradient);
              }
              .st5 {
                fill: #444f5b;
              }
            `}
          </style>
          <linearGradient id="linear-gradient" x1="28.9" y1="-124.5" x2="-1.7" y2="-124.5" gradientTransform="translate(-33.5 136) rotate(17.8)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#afca0b"/>
            <stop offset="1" stopColor="#3fa535"/>
          </linearGradient>
          <linearGradient id="linear-gradient1" x1="43" y1="-124.5" x2="73.5" y2="-124.5" xlinkHref="#linear-gradient"/>
          <linearGradient id="linear-gradient2" x1="35.9" y1="-122.1" x2="35.9" y2="-81.8" gradientTransform="translate(-33.5 136) rotate(17.8)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#0093d6"/>
            <stop offset="1" stopColor="#283c90"/>
          </linearGradient>
          <radialGradient id="radial-gradient" cx="35.9" cy="-129.8" fx="35.9" fy="-129.8" r="5.6" gradientTransform="translate(-33.5 136) rotate(17.8)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#0093d6"/>
            <stop offset="1" stopColor="#0069b4"/>
          </radialGradient>
        </defs>
        <g>
          <g>
            <polygon className="st5" points="25.5 69.8 44.2 44.5 40.6 32.4 35.1 30.6 25.1 37.8 25.5 69.8"/>
            <path className="st5" d="M45.4,25.8c-.9,2.9-4.1,4.5-7,3.6-2.9-.9-4.5-4.1-3.6-7,.9-2.9,4.1-4.5,7-3.6,2.9.9,4.5,4.1,3.6,7Z"/>
          </g>
          <g>
            <polygon className="st5" points=".5 24.5 21.4 13.8 31.8 20.9 31.9 26.7 22 34.1 .5 24.5"/>
            <polygon className="st5" points="72.1 47.5 61.3 26.6 48.7 26.4 45.3 31 49 42.8 72.1 47.5"/>
          </g>
          <polygon className="st4" points=".8 23.5 21.7 12.9 32.1 20 32.2 25.7 22.3 33.2 .8 23.5"/>
          <polygon className="st2" points="72.4 46.5 61.6 25.7 49 25.4 45.6 30 49.3 41.9 72.4 46.5"/>
          <polygon className="st1" points="25.7 69.1 44.5 43.8 40.8 31.7 35.4 29.9 25.3 37.1 25.7 69.1"/>
          <path className="st3" d="M45.6,25.1c-.9,2.9-4.1,4.5-7,3.6-2.9-.9-4.5-4.1-3.6-7,.9-2.9,4.1-4.5,7-3.6,2.9.9,4.5,4.1,3.6,7Z"/>
          <polygon className="st5" points="24.4 11.4 47.5 1.1 60.4 23 51.4 22.4 45.3 8 31.9 16.2 24.4 11.4"/>
        </g>
        <g>
          <path className="st5" d="M93.7,55c-1.2.7-3.1,1-5.6,1-6,0-8.9-3.1-8.9-9.3v-12.6h-4.4v-6.2h4.4v-5.9l8.4-2.4v8.3h6.2v6.2h-6.2v11.1c0,2.9,1.1,4.3,3.4,4.3s1.8-.3,2.8-.8v6.3Z"/>
          <path className="st5" d="M118.4,44.1h-17.9c.3,4,2.8,6,7.5,6s5.7-.7,7.9-2.1v6.1c-2.5,1.4-5.8,2-9.9,2s-7.9-1.2-10.3-3.7-3.7-5.9-3.7-10.3,1.3-8.2,4-10.8c2.6-2.7,5.9-4,9.7-4s7.1,1.2,9.3,3.6c2.2,2.4,3.3,5.6,3.3,9.7v3.6ZM110.6,38.9c0-3.9-1.6-5.9-4.8-5.9s-2.5.6-3.5,1.7c-1,1.1-1.6,2.5-1.8,4.2h10.1Z"/>
          <path className="st5" d="M146.6,55.4h-10.1l-8.8-13.6h-.1v13.6h-8.5V14.8h8.5v25.8h.1l8.2-12.7h10l-9.8,12.9,10.5,14.5Z"/>
          <path className="st5" d="M171.8,55.4h-8.4v-15.2c0-4.2-1.5-6.4-4.6-6.4s-2.7.6-3.6,1.7c-.9,1.1-1.4,2.6-1.4,4.3v15.6h-8.5v-27.4h8.5v4.3h.1c2-3.3,5-5,8.8-5,6.1,0,9.1,3.8,9.1,11.3v16.8Z"/>
          <path className="st5" d="M187.2,56c-4.6,0-8.2-1.3-10.8-3.8-2.6-2.6-3.9-6-3.9-10.4s1.4-8.1,4.1-10.6c2.7-2.6,6.4-3.8,11-3.8s8.1,1.3,10.7,3.8c2.6,2.6,3.9,5.9,3.9,10.2s-1.3,8.1-4,10.8c-2.7,2.6-6.3,4-11,4ZM187.4,33.8c-2,0-3.6.7-4.7,2.1-1.1,1.4-1.7,3.3-1.7,5.8,0,5.3,2.1,7.9,6.4,7.9s6.1-2.7,6.1-8.1-2-7.7-6.1-7.7Z"/>
          <path className="st0" d="M211.7,55.4h-8.5V14.8h8.5v40.6Z"/>
          <path className="st0" d="M227.5,56c-4.6,0-8.2-1.3-10.8-3.8-2.6-2.6-3.9-6-3.9-10.4s1.4-8.1,4.1-10.6c2.7-2.6,6.4-3.8,11-3.8s8.1,1.3,10.7,3.8c2.6,2.6,3.9,5.9,3.9,10.2s-1.3,8.1-4,10.8c-2.7,2.6-6.3,4-11,4ZM227.7,33.8c-2,0-3.6.7-4.7,2.1-1.1,1.4-1.7,3.3-1.7,5.8,0,5.3,2.1,7.9,6.4,7.9s6.1-2.7,6.1-8.1-2-7.7-6.1-7.7Z"/>
          <path className="st0" d="M252.1,52.2h-.1v3.2h-8.5V14.8h8.5v17.3h.1c2.1-3.2,5.1-4.8,8.9-4.8s6.3,1.2,8.2,3.6c1.9,2.4,2.9,5.7,2.9,10s-1.1,8.2-3.3,11c-2.2,2.8-5.2,4.1-8.9,4.1s-5.9-1.3-7.7-3.9ZM251.9,40.6v2.8c0,1.8.5,3.2,1.5,4.4,1,1.2,2.3,1.7,3.9,1.7s3.4-.7,4.5-2.2c1.1-1.5,1.6-3.6,1.6-6.3s-.5-4-1.5-5.3c-1-1.3-2.4-1.9-4.2-1.9s-3.1.6-4.2,1.9-1.7,2.9-1.7,5Z"/>
          <path className="st0" d="M277.5,23.6c-1.4,0-2.6-.4-3.5-1.3-.9-.8-1.4-1.9-1.4-3.1s.5-2.3,1.4-3.1c.9-.8,2.1-1.2,3.5-1.2s2.6.4,3.5,1.2c.9.8,1.4,1.8,1.4,3.1s-.5,2.3-1.4,3.2-2.1,1.2-3.5,1.2ZM281.7,55.4h-8.5v-27.4h8.5v27.4Z"/>
        </g>
      </svg>
    </LogoContainer>
  );
}